//TODO use this in scriptMetadata
export interface ScriptParameters {
  [key: string]: {
    name: string
    type: ScriptParameterType
    help_text?: string // Description of the parameter
    validation_pattern?: string // Regex pattern for validation
    default_value?: string // Default value for the parameter
    options?: string[] // For dropdowns, this will contain the list of options
    required?: boolean // Indicates if the parameter is required

    //project specific parameters
    selectable_project_ids?: string[] // For PROJECT_ID type
    project_display_name?: string[] // For PROJECT_ID type, display name of the projects
    allow_multiple_projects?: boolean // For PROJECT_ID type, allows multiple selections
  }
}

// Type for form values
export type FormParameterValues = Record<
  string,
  string | number | boolean | string[] | Date
> & {
  output_project?: string // Always include output project
}

// Type for script execution parameters
export type ScriptExecutionParameters = Record<
  string,
  string | number | boolean | string[]
>

// Type for output project selection
export interface OutputProject {
  project_id: string
  owner: string
}

export interface RunAutomationScriptResponse {
  result: {
    job_id: string
    status: string
  }
}

export interface AvailableScriptsResponse {
  result: { public: string[]; private: string[] }
}

export interface JobListResponse {
  job_id: string
  script: string
  status: JOB_STATUS
  user_name: string
  unit_name: string
  exit_code?: number
  duration_seconds?: number
  elapsed_seconds?: number
}
export interface JobStatusResponse {
  job_id: string
  script: string
  status: JOB_STATUS
  user: string
  unit: string
  stdout_output?: string
  stderr_output?: string
  elapsed_seconds?: number
}
// Updated to match your backend response format
export interface ScriptMetadata {
  name: string
  description?: string
  script_type: string // e.g., "python", "bash", etc.
  parameters: Array<{
    name: string
    type: ScriptParameterType
    required?: boolean
    help_text?: string
    validation_pattern?: string
    default_value?: string | number | boolean
    options?: string[]
    selectable_project_ids?: string[]
    project_display_name?: string[]
    allow_multiple_projects?: boolean
  }>
  timeout_minutes?: number // Optional timeout in minutes
}

export enum JOB_STATUS {
  QUEUED = "QUEUED",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  TIMEOUT = "TIMEOUT",
}

export enum ScriptParameterType {
  TEXT = "TEXT",
  NUMBER = "NUMBER",
  BOOLEAN = "BOOLEAN",
  DROPDOWN = "DROPDOWN",
  PROJECT_ID = "PROJECT_ID",
  FILE_PATH = "FILE_PATH",
  DATE = "DATE",
  MULTITEXT = "MULTITEXT",
}
